import React from 'react';
import { cn } from '../../lib/utils';

interface CategoryOwnerAvatarProps {
  name: string;
  profilePic?: string;
  className?: string;
  size?: 'sm' | 'md' | 'lg';
}

/**
 * CategoryOwnerAvatar component that displays either the owner's profile picture or their initials
 */
export const CategoryOwnerAvatar: React.FC<CategoryOwnerAvatarProps> = ({ 
  name,
  profilePic,
  className, 
  size = 'md' 
}) => {
  // Generate user initials from name
  const userInitials = name
    ?.split(' ')
    ?.map((n: string) => n[0])
    ?.join('')
    ?.toUpperCase() || '?';
  
  // Determine size classes
  const sizeClasses = {
    sm: 'h-8 w-8 text-xs',
    md: 'h-10 w-10 text-sm',
    lg: 'h-12 w-12 text-base'
  };
  
  return (
    <div 
      className={cn(
        'rounded-full flex items-center justify-center overflow-hidden',
        sizeClasses[size],
        className
      )}
    >
      {profilePic ? (
        <img 
          src={profilePic} 
          alt={`${name}'s profile`}
          className="h-full w-full object-cover"
        />
      ) : (
        <div className="bg-blue-100 dark:bg-blue-800 h-full w-full flex items-center justify-center">
          <span className="font-medium text-blue-600 dark:text-blue-200">
            {userInitials}
          </span>
        </div>
      )}
    </div>
  );
};

export default CategoryOwnerAvatar;